import React from 'react';
import { DatePicker } from '@fluentui/react';
import type { IDatePickerProps } from '@fluentui/react';

/**
 * EditableDatePicker - A wrapper around Fluent UI's DatePicker with enhanced usability
 * 
 * Features:
 * - Manual text entry enabled
 * - Date format: mm/dd/yyyy
 * - Auto-selects all text when focused for easy editing
 * - Calendar only opens when clicking the calendar icon (not when clicking in text field)
 */
export const EditableDatePicker: React.FC<IDatePickerProps> = (props) => {
  // Default format date to mm/dd/yyyy
  const defaultFormatDate = (date?: Date): string => {
    if (!date) return '';
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return (
    <DatePicker
      {...props}
      allowTextInput={true}
      disableAutoFocus={true}
      formatDate={props.formatDate || defaultFormatDate}
      textField={{
        ...props.textField,
        onFocus: (e) => {
          e.target.select();
          props.textField?.onFocus?.(e);
        },
        onClick: (e) => {
          e.stopPropagation();
          props.textField?.onClick?.(e);
        },
      }}
    />
  );
};
